import * as React from "react"

export interface Layout<T> {
  mobile: T
  tablet: T
  desktop: T
}

export const sameLayout = <T>(x: T): Layout<T> => ({
  mobile: x,
  tablet: x,
  desktop: x,
})

export const defaultSameLayoutString = <T extends string>(
  x: T | Layout<T>
): Layout<T> => (typeof x === "string" ? sameLayout(x) : x)

export const useMemoLayout = <T extends string>(
  x: T | Layout<T>
): Layout<T> => {
  const { mobile, tablet, desktop } = defaultSameLayoutString(x)
  return React.useMemo(
    () => ({ mobile, tablet, desktop }),
    [mobile, tablet, desktop]
  )
}

export type TextAlignment = "left" | "center" | "right"
